import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-sirius-ng',
  template: `
    <p>
      lib-sirius-ng works!
    </p>
  `,
  styles: []
})
export class LibSiriusNgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
